// extracted by mini-css-extract-plugin
export default {"daviplataPaymentMethodWrapper":"daviplataPaymentMethodWrapper__+loD+","title":"title__ITuGJ","theDaviplataLogo":"theDaviplataLogo__Z7pyr"};